export default "__VITE_ASSET__BVo$S103__"